import { render, staticRenderFns } from "./Mixare.vue?vue&type=template&id=0b8d6d2b&scoped=true&"
import script from "./Mixare.vue?vue&type=script&lang=js&"
export * from "./Mixare.vue?vue&type=script&lang=js&"
import style0 from "./Mixare.vue?vue&type=style&index=0&id=0b8d6d2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d6d2b",
  null
  
)

export default component.exports